import React from "react";
import { SanitizedHtml } from "#app/components/editor/sanitized-html";
import type { Omittable } from "@salestrak/ui";

type NoteContentProps = Omittable<{
  content: string;
  /** Fired with the clicked inline image's src (see SanitizedHtml). */
  onImageClick?: (src: string) => void;
  /** Saves a checklist tick (see SanitizedHtml); absent, boxes are read-only. */
  onTaskToggle?: (index: number, checked: boolean) => Promise<boolean>;
}>;

/**
 * Renders sanitized HTML content from TipTap/ProseMirror notes.
 * The server is the authoritative XSS defense; this client pass is a second layer.
 *
 * Inline photo srcs are stored as canonical /media/:id/content paths
 * (permission-gated, not directly loadable by an image tag) — SanitizedHtml
 * swaps them for authenticated object URLs after its sanitize pass.
 */
export function NoteContent({ content, onImageClick, onTaskToggle }: NoteContentProps) {
  return (
    <SanitizedHtml
      html={content}
      onImageClick={onImageClick}
      onTaskToggle={onTaskToggle}
      mediaThumbnails
    />
  );
}
